"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToPrescriptions = exports.deletePrescriptionRealTime = exports.editPrescriptionRealTime = exports.addPrescriptionRealTime = exports.editPrescription = exports.deletePrescription = exports.addPrescription = exports.fetchPrescriptionById = exports.fetchPrescriptionsByCenterStatus = exports.fetchPrescriptionsInBatches = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var supabaseClient_1 = require("../../supabaseClient"); // Adjust the import path as needed
var initialState = {
    data: [],
    status: "idle",
    error: null,
    globalData: {},
    loaded: false,
};
// Fetch all prescriptions
exports.fetchPrescriptionsInBatches = (0, toolkit_1.createAsyncThunk)("prescriptions/fetchPrescriptionsInBatches", function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase.from("prescriptions").select("*")];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch all prescriptions
exports.fetchPrescriptionsByCenterStatus = (0, toolkit_1.createAsyncThunk)("prescriptions/fetchPrescriptionsByCenterStatus", function (_a, _b) {
    var centerID = _a.centerID, status = _a.status;
    var rejectWithValue = _b.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _c, data, error;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("prescriptions")
                        .select("*")
                        .eq("center_id", centerID)
                        .eq("status", status)
                        .order("created_at", { ascending: false })];
                case 1:
                    _c = _d.sent(), data = _c.data, error = _c.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Fetch prescription by ID
exports.fetchPrescriptionById = (0, toolkit_1.createAsyncThunk)("prescriptions/fetchPrescriptionById", function (id, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, error;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, supabaseClient_1.supabase
                        .from("prescriptions")
                        .select("*")
                        .eq("id", id)
                        .single()];
                case 1:
                    _b = _c.sent(), data = _b.data, error = _b.error;
                    if (error) {
                        return [2 /*return*/, rejectWithValue(error.message)];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
});
// Add a new prescription
exports.addPrescription = (0, toolkit_1.createAsyncThunk)("prescriptions/addPrescription", function (newPrescription, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("prescriptions")
                    .insert(newPrescription)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data];
        }
    });
}); });
// Delete a prescription
exports.deletePrescription = (0, toolkit_1.createAsyncThunk)("prescriptions/deletePrescription", function (id, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("prescriptions")
                    .delete()
                    .eq("id", id)];
            case 1:
                error = (_a.sent()).error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, id];
        }
    });
}); });
// Edit a prescription
exports.editPrescription = (0, toolkit_1.createAsyncThunk)("prescriptions/editPrescription", function (updatedPrescription, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, supabaseClient_1.supabase
                    .from("prescriptions")
                    .update(updatedPrescription)
                    .eq("id", updatedPrescription.id)
                    .select()
                    .single()];
            case 1:
                _a = _b.sent(), data = _a.data, error = _a.error;
                if (error) {
                    return [2 /*return*/, thunkApi.rejectWithValue(error.message)];
                }
                return [2 /*return*/, data];
        }
    });
}); });
// Real-time actions
var addPrescriptionRealTime = function (newPrescription) { return ({
    type: "prescriptions/addPrescriptionRealTime",
    payload: newPrescription,
}); };
exports.addPrescriptionRealTime = addPrescriptionRealTime;
var editPrescriptionRealTime = function (updatedPrescription) { return ({
    type: "prescriptions/editPrescriptionRealTime",
    payload: updatedPrescription,
}); };
exports.editPrescriptionRealTime = editPrescriptionRealTime;
var deletePrescriptionRealTime = function (id) { return ({
    type: "prescriptions/deletePrescriptionRealTime",
    payload: id,
}); };
exports.deletePrescriptionRealTime = deletePrescriptionRealTime;
// Slice definition
var prescriptionsSlice = (0, toolkit_1.createSlice)({
    name: "prescriptions",
    initialState: initialState,
    reducers: {
        addPrescriptionRealTime: function (state, action) {
            var exists = state.data.some(function (item) { return item.id === action.payload.id; });
            if (!exists) {
                state.data.push(action.payload);
            }
            state.error = null;
        },
        editPrescriptionRealTime: function (state, action) {
            var index = state.data.findIndex(function (item) { return item.id === action.payload.id; });
            if (index !== -1) {
                state.data[index] = action.payload;
            }
            state.error = null;
        },
        deletePrescriptionRealTime: function (state, action) {
            state.data = state.data.filter(function (item) { return item.id !== action.payload; });
            state.error = null;
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(exports.fetchPrescriptionsInBatches.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchPrescriptionsInBatches.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            action.payload.forEach(function (item) {
                var _a;
                state.globalData[(_a = item.id) !== null && _a !== void 0 ? _a : ""] = item;
            });
            state.status = "succeeded";
        })
            .addCase(exports.fetchPrescriptionsInBatches.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch prescriptions.";
        })
            .addCase(exports.fetchPrescriptionsByCenterStatus.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchPrescriptionsByCenterStatus.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = action.payload;
            state.status = "succeeded";
        })
            .addCase(exports.fetchPrescriptionsByCenterStatus.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch prescriptions.";
        })
            .addCase(exports.fetchPrescriptionById.pending, function (state) {
            state.status = "loading";
        })
            .addCase(exports.fetchPrescriptionById.fulfilled, function (state, action) {
            state.loaded = true;
            state.data = [action.payload];
            state.status = "succeeded";
        })
            .addCase(exports.fetchPrescriptionById.rejected, function (state, action) {
            state.status = "failed";
            state.error =
                action.payload || "Failed to fetch prescription.";
        })
            .addCase(exports.addPrescription.fulfilled, function (state, action) {
            state.data.push(action.payload);
            state.error = null;
        })
            .addCase(exports.addPrescription.rejected, function (state, action) {
            state.error = action.payload || "Failed to add prescription.";
        })
            .addCase(exports.deletePrescription.fulfilled, function (state, action) {
            state.data = state.data.filter(function (item) { return item.id !== action.payload; });
            state.error = null;
        })
            .addCase(exports.deletePrescription.rejected, function (state, action) {
            state.error = action.payload || "Failed to delete prescription.";
        })
            .addCase(exports.editPrescription.fulfilled, function (state, action) {
            var index = state.data.findIndex(function (item) { return item.id === action.payload.id; });
            if (index !== -1) {
                state.data[index] = action.payload;
            }
            state.error = null;
        })
            .addCase(exports.editPrescription.rejected, function (state, action) {
            state.error = action.payload || "Failed to edit prescription.";
        });
    },
});
// Real-time subscription function
var subscribeToPrescriptions = function (dispatch) {
    var subscription = supabaseClient_1.supabase
        .channel("public:prescriptions")
        .on("postgres_changes", { event: "*", schema: "public", table: "prescriptions" }, function (payload) {
        var _a, _b;
        var newRecord = payload.new;
        var oldRecord = payload.old;
        switch (payload.eventType) {
            case "INSERT":
                dispatch((0, exports.addPrescriptionRealTime)(newRecord));
                break;
            case "UPDATE":
                if (newRecord.status == 2 || newRecord.status == 3)
                    dispatch((0, exports.deletePrescriptionRealTime)((_a = oldRecord.id) !== null && _a !== void 0 ? _a : ""));
                else
                    dispatch((0, exports.editPrescriptionRealTime)(newRecord));
                break;
            case "DELETE":
                dispatch((0, exports.deletePrescriptionRealTime)((_b = oldRecord.id) !== null && _b !== void 0 ? _b : ""));
                break;
            default:
                break;
        }
    })
        .subscribe();
    return function () {
        subscription.unsubscribe();
    };
};
exports.subscribeToPrescriptions = subscribeToPrescriptions;
exports.default = prescriptionsSlice.reducer;
